var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group", class: _vm.computedClasses }, [
    _c("input", {
      ref: "materialInput",
      staticClass: "form-control form-control-rangedatepicker",
      class: _vm.inputClasses,
      attrs: {
        id: `form-control-rangedatepicker-${_vm.id}`,
        type: "text",
        name: _vm.name,
        placeholder: _vm.placeholder,
        readonly: true,
        disabled: _vm.disabled,
        autocomplete: _vm.autocomplete,
        required: _vm.required,
      },
      domProps: { value: _vm.rangeText },
      on: {
        input: function ($event) {
          return _vm.handleModelInput(true)
        },
        focus: function ($event) {
          return _vm.handleFocus(true)
        },
        blur: function ($event) {
          return _vm.handleFocus(false)
        },
      },
    }),
    _vm._v(" "),
    _c(
      "label",
      {
        staticClass: "material-label",
        class: _vm.activeClass,
        attrs: { for: `form-control-rangedatepicker-${_vm.id}` },
      },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _vm.error
      ? _c("small", { staticClass: "invalid-feedback" }, [
          _vm._v(_vm._s(_vm.error)),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }